import type { AnyDescriptor, DimensionDescriptor } from "../../../../../api/types/svTypes.ts";
import { ItemDataType, ReportType } from "../../../../../api/types/svTypes.ts";

const allReportTypes = Object.values(ReportType).filter(
  (type) => type !== ReportType.CashFlow && type !== ReportType.FinancialStatement
);
const defaultConditionOptions = { allowedReportTypes: allReportTypes };

const dataTypesAllowedInConditions: ItemDataType[] = [ItemDataType.General, ItemDataType.Date];

const getConditionReportType = (reportType: ReportType): ReportType => {
  if (reportType === ReportType.CashFlow) {
    return ReportType.Tabular;
  }
  // Stored custom dimensions predate FinancialStatement, so it reads the Pivot policy.
  return reportType === ReportType.FinancialStatement ? ReportType.Pivot : reportType;
};

export const isAllowedInConditions = (meta: AnyDescriptor, reportType?: ReportType): boolean => {
  if (!dataTypesAllowedInConditions.includes(meta.type)) {
    return false;
  }
  const options = ("options" in meta ? meta.options?.conditions : undefined) ?? defaultConditionOptions;
  return reportType !== undefined
    ? options.allowedReportTypes.includes(getConditionReportType(reportType))
    : allReportTypes.every((type) => options.allowedReportTypes.includes(type));
};

export const getDimensionsAllowedInConditions = (
  dimensions: DimensionDescriptor[],
  reportType?: ReportType
): DimensionDescriptor[] => dimensions.filter((dimension) => isAllowedInConditions(dimension, reportType));
